import { ValidateTaxpayerOtpRequest } from '../../Services/ClientProxy/clientProxy';

export const OTPVerifyUser = 'OTPVerifyUser';
export const OTPVerifyTaxpayer = 'OTPVerifyTaxpayer';
export const OTPVerifyIntermediary = 'OTPVerifyIntermediary';

export interface VerifyUser {
    type: typeof OTPVerifyUser;
    payload: ValidateTaxpayerOtpRequest;
    Code: string;
    userid: string;
}

export interface VerifyTaxPayer {
    type: typeof OTPVerifyTaxpayer;
    payload: ValidateTaxpayerOtpRequest;
    Code: string;
    Rin: string;
}

export interface VerifyIntermediary {
    type: typeof OTPVerifyIntermediary;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload: any;
}


export type VerficationActionTypes = VerifyUser | VerifyTaxPayer | VerifyIntermediary;
